/*
 * @Author: cmchiu
 * @Date: 2023-03-21 13:23:44
 * @LastEditTime: 2023-05-10 11:41:20
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\main.js
 *
 */
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(ElementUI, { locale, zIndex: 1000 })

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
